import { LoginMethod, typedKeys, validateEmail } from '@mi-front/core';
import {
  Alert,
  AlertTitle,
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { isSocialEmail } from '../../../../../../helpers/email';
import { UsersAddValues } from '../../create/createUserForm.schema';
import {
  loginMethodDescriptionMessages,
  loginMethodFieldLabel,
  loginMethodLabelMessages,
} from '../../messages';
import { loginMethodIconMap } from '../LoginMethodIconMap';

export function LoginMethodField() {
  const { formatMessage } = useIntl();
  const { setValue } = useFormContext();
  const email = useWatch<UsersAddValues>({ name: 'email' });
  const loginMethod = useWatch<UsersAddValues>({ name: 'loginMethod' });

  useEffect(() => {
    // if the email is valid, update the method option
    // according to the email type (social email or not)
    if (email && validateEmail(email)) {
      setValue(
        'loginMethod',
        isSocialEmail(email) ? LoginMethod.SOCIAL_LOGIN : LoginMethod.USERNAME_PASSWORD,
      );
    }
  }, [email]);

  return (
    <Box mb={1}>
      <FormControl>
        <div className={'form-label'}>* {formatMessage(loginMethodFieldLabel)}</div>
        <RadioGroup
          row
          value={loginMethod}
          onChange={(evt, value) => {
            setValue('loginMethod', value);
          }}
        >
          {typedKeys(LoginMethod).map((method) => (
            <React.Fragment key={method}>
              <FormControlLabel
                value={method}
                control={<Radio />}
                label={formatMessage(loginMethodLabelMessages[method])}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </React.Fragment>
          ))}
        </RadioGroup>
      </FormControl>

      {!!loginMethod && (
        <Alert
          key={loginMethod}
          severity={'info'}
          sx={{ maxWidth: '50rem' }}
          icon={loginMethodIconMap[loginMethod as LoginMethod]}
        >
          <AlertTitle>
            {formatMessage(loginMethodLabelMessages[loginMethod as LoginMethod])}:
          </AlertTitle>
          <div>{formatMessage(loginMethodDescriptionMessages[loginMethod as LoginMethod])}</div>
        </Alert>
      )}
    </Box>
  );
}
